import React from "react";
import { Navigate } from "react-router-dom";
import { useDealerAuth } from "../../context/DealerAuthContext";

export default function DealerRouteGuard({ children }) {
  const { dealer, loading } = useDealerAuth();

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "#003566",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          color: "#FFD60A",
          fontSize: 18,
          fontFamily: "serif",
          letterSpacing: 2
        }}>
          Loading...
        </div>
      </div>
    );
  }

  if (!dealer) return <Navigate to="/dealer/login" replace />;

  return children;
}